import { createApi } from '@reduxjs/toolkit/query/react'
import { CHATTER_CLIENT_ATTENDANCE_LIST, CHATTER_CLIENT_DETAIL, CHATTER_CLIENT_LIST, CHATTER_CLIENT_UPDATE, CHATTER_PROGRAMS_ASSIGNED, FAVOURITE_CHATTER_CLIENT } from 'config/apiPaths';
import { RTK_CACHE_EXPIRATION } from "config/constants";
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const chatterClientsApi = createApi({
    reducerPath: 'chatterClientsApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/client/chatter",
    }),
    tagTypes: ["ChatterClients", "ChatterClientDetails"],
    keepUnusedDataFor: RTK_CACHE_EXPIRATION,
    endpoints: (builder) => ({

        // Chatter clients list
        getChatterClientsList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, funding_source = "", program_name = "", sort = { column: "id", direction: "ASC" } }) => ({
                method: "PATCH",
                url: CHATTER_CLIENT_LIST,
                data: { search, status: status?.value || "", funding_source: funding_source?.value || "", page, limit, program_name, sort }
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ChatterClients"]
        }),

        // chatter client details
        chatterClientDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${CHATTER_CLIENT_DETAIL}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ChatterClientDetails", "ChatterPrograms"]
        }),

        // update client
        updateChatterClient: builder.mutation({
            query: (data) => ({
                method: "PUT",
                url: `${CHATTER_CLIENT_UPDATE}/${data.id}`,
                data: data.payload
            }),
            invalidatesTags: ["ChatterClients", "ChatterClientDetails", "ChatterPrograms", "ChatterClientAttendance"]
        }),

        getChatterProgramsList: builder.query({
            query: ({ search = "", status = "", id = "", page = 1, limit = 5, sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: `${CHATTER_PROGRAMS_ASSIGNED}/${id}`,
                data: { search, status, page, limit, sort },
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ChatterPrograms"]
        }),

        favouriteChatterClient: builder.mutation({
            query: ({ data, id }) => ({
                method: "PATCH",
                url: `${FAVOURITE_CHATTER_CLIENT}/${id}`,
                data
            }),
            invalidatesTags: ["ChatterPrograms", "ChatterClients", "ChatterClientDetails", 'ChatterClientAttendance']
        }),

        getChatterClientAttendance: builder.query({
            query: ({ clientId }) => ({
                method: "PATCH",
                url: `${CHATTER_CLIENT_ATTENDANCE_LIST}/${clientId}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ChatterClientAttendance"]
        }),
    })
})

export const {
    useGetChatterClientsListQuery,
    useChatterClientDetailsQuery,
    useLazyGetChatterClientsListQuery,
    useUpdateChatterClientMutation,
    useGetChatterProgramsListQuery,
    useFavouriteChatterClientMutation,
    useGetChatterClientAttendanceQuery
} = chatterClientsApi;